import { createTheme } from '@mui/material/styles';

export const retroTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#7dd3c7',
    },
    secondary: {
      main: '#f472b6',
    },
    background: {
      default: '#0b1418',
      paper: '#0f1c22',
    },
    text: {
      primary: '#d1e7e4',
      secondary: '#8fb3b0',
    },
    divider: '#1f3a40',
  },

  typography: {
    fontFamily: `'IBM Plex Mono', 'Courier New', monospace`,
    h1: { fontWeight: 600, letterSpacing: '-0.02em' },
    h2: { fontWeight: 500 },
    body1: { lineHeight: 1.6 },
  },

  shape: {
    borderRadius: 2,
  },

  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          /* Base CRT bloom */
          textShadow: `
            0 0 1px rgba(125,211,199,0.25),
            0 0 6px rgba(125,211,199,0.15)
          `,
        },

        /* Stronger bloom for headings */
        h1: {
          textShadow: `
            0 0 2px rgba(125,211,199,0.45),
            0 0 12px rgba(125,211,199,0.25)
          `,
        },
        h2: {
          textShadow: `
            0 0 2px rgba(125,211,199,0.4),
            0 0 10px rgba(125,211,199,0.2)
          `,
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage:
            'linear-gradient(180deg, rgba(255,255,255,0.03), rgba(0,0,0,0.2))',
          border: '1px solid #1f3a40',
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 2,
        },
      },
    },
  },
});
